import { httpClient as http } from '@/utils/http'

// API基础路径
const API_BASE = '/mdm/billingUnit'

// 基础分页请求
export interface PageRequest {
  pageNum: number
  pageSize: number
}

// 分页结果
export interface PageResultVO<T> {
  records: T[]
  total: number
  pageNum: number
  pageSize: number
}

// 计费单位分页查询请求
export interface BillingUnitPageRequest extends PageRequest {
  tenantId?: string
  unitNameCn?: string
  unitNameEn?: string
  isContainerUnit?: number
  enabled?: number
  keyword?: string
}

// 计费单位列表项视图对象
export interface BillingUnitListVO {
  id: string
  tenantId?: string
  unitNameCn: string
  unitNameEn: string
  isContainerUnit: number
  enabled: number
  containerType?: string
  isPlatformData?: boolean
}

// 计费单位详情视图对象
export interface BillingUnitVO {
  id: string
  tenantId?: string
  unitNameCn: string
  unitNameEn: string
  isContainerUnit: number
  enabled: number
  containerType?: string
  isPlatformData?: boolean
}

// 计费单位保存请求
export interface BillingUnitSaveRequest {
  id?: string
  tenantId?: string
  unitNameCn: string
  unitNameEn: string
  isContainerUnit: number
  containerType?: string
  enabled?: number
}

// 模糊搜索请求
export interface FuzzySearchRequest {
  keyword: string
  enabled?: number
  isContainerUnit?: number
}

// 名称查询请求
export interface NameQueryRequest {
  unitNameCn?: string
  unitNameEn?: string
}

// 批量删除请求
export interface BatchDeleteRequest {
  ids: string[]
}

// 批量状态更新请求
export interface BatchUpdateStatusRequest {
  ids: string[]
  enabled: number
}

// 批量关联请求
export interface BatchAssociateRequest {
  platformIds: string[]
}

// 批量解除关联请求
export interface BatchDisassociateRequest {
  associationIds?: string[]
  platformIds?: string[]
}

// 计费单位API
export const billingUnitApi = {
  // 分页查询计费单位列表
  page: (params: BillingUnitPageRequest) => {
    return http.post<PageResultVO<BillingUnitListVO>>(`${API_BASE}/queryPage`, params)
  },

  // 查询计费单位列表
  list: (params: BillingUnitPageRequest) => {
    return http.post<BillingUnitListVO[]>(`${API_BASE}/queryList`, params)
  },

  // 模糊搜索计费单位
  search: (params: FuzzySearchRequest) => {
    return http.post<BillingUnitListVO[]>(`${API_BASE}/search`, params)
  },

  // 根据ID获取计费单位详情
  getById: (params: { id: string }) => {
    return http.post<BillingUnitVO>(`${API_BASE}/getById`, params)
  },

  // 保存计费单位（新增或更新）
  save: (params: BillingUnitSaveRequest) => {
    return http.post<boolean>(`${API_BASE}/save`, params)
  },

  // 删除计费单位
  delete: (params: BatchDeleteRequest) => {
    return http.post<boolean>(`${API_BASE}/delete`, params)
  },

  // 更新状态
  updateStatus: (params: BatchUpdateStatusRequest) => {
    return http.post<boolean>(`${API_BASE}/updateStatus`, params)
  },

  // 批量更新状态
  batchUpdateStatus: (params: BatchUpdateStatusRequest) => {
    return http.post<boolean>(`${API_BASE}/batchUpdateStatus`, params)
  },

  // 根据名称查询计费单位
  getByName: (params: NameQueryRequest) => {
    return http.post<BillingUnitVO>(`${API_BASE}/getByName`, params)
  },

  // 查询容器型计费单位列表
  queryContainer: (params: BillingUnitPageRequest) => {
    return http.post<BillingUnitListVO[]>(`${API_BASE}/queryContainer`, params)
  },

  // 查询非容器型计费单位列表
  queryNonContainer: (params: BillingUnitPageRequest) => {
    return http.post<BillingUnitListVO[]>(`${API_BASE}/queryNonContainer`, params)
  },

  // 查询启用状态的计费单位
  queryEnabled: (params: BillingUnitPageRequest) => {
    return http.post<BillingUnitListVO[]>(`${API_BASE}/queryEnabled`, params)
  },

  // 查询可关联的平台计费单位（分页）
  queryPlatformPage: (params: BillingUnitPageRequest) => {
    return http.post<PageResultVO<BillingUnitListVO>>(`${API_BASE}/queryPlatformPage`, params)
  },

  // 查询可关联的平台计费单位（列表）
  queryPlatformList: (params: BillingUnitPageRequest) => {
    return http.post<BillingUnitListVO[]>(`${API_BASE}/queryPlatformList`, params)
  },

  // 批量关联平台计费单位
  batchAssociate: (params: BatchAssociateRequest) => {
    return http.post<boolean>(`${API_BASE}/batchAssociate`, params)
  },

  // 批量解除关联平台计费单位
  batchDisassociate: (params: BatchDisassociateRequest) => {
    return http.post<boolean>(`${API_BASE}/batchDisassociate`, params)
  }
}
